import { Instagram, MessageCircle, Navigation, Phone } from "lucide-react";
import { t } from "@/lib/i18n";
import { Pending } from "@/components/Pending";

export const CONTACT_ITEMS = [
  { key: "phone", label: "iletisim.phone", Icon: Phone },
  { key: "whatsapp", label: "iletisim.whatsapp", Icon: MessageCircle, external: true },
  { key: "instagram", label: "iletisim.instagram", Icon: Instagram, external: true },
  { key: "directions", label: "iletisim.directions", Icon: Navigation, external: true },
];

export default function ContactLinks({ links, isPreview, dark = false }) {
  const items = CONTACT_ITEMS.filter((i) => links[i.key] || isPreview);
  if (!items.length) return null;
  const tone = dark ? "bg-white/[0.06] border-white/15 text-cream" : "bg-white border-line text-ink";
  return (
    <ul className="grid gap-3 sm:grid-cols-2" data-testid="contact-links">
      {items.map(({ key, label, Icon, external }) => {
        const l = links[key];
        const inner = (
          <>
            <span className={`inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-full ${dark ? "bg-gold-light text-forest-dark" : "bg-forest text-cream"}`}>
              <Icon className="h-5 w-5" aria-hidden="true" />
            </span>
            <span className="min-w-0">
              <span className="block text-sm font-semibold">{t(label)}</span>
              {l ? <span className={`block truncate text-sm ${dark ? "text-cream/80" : "text-ink-muted"}`}>{l.label}</span> : <Pending className="mt-1" testId={`contact-${key}-pending`} />}
            </span>
          </>
        );
        return (
          <li key={key}>
            {l ? (
              <a href={l.href} {...(external ? { target: "_blank", rel: "noopener noreferrer" } : {})} className={`flex items-center gap-4 min-h-[72px] rounded-2xl border px-5 py-3 transition-colors hover:border-honey ${tone}`} data-testid={`contact-${key}-link`}>
                {inner}
              </a>
            ) : (
              <div className={`flex items-center gap-4 min-h-[72px] rounded-2xl border border-dashed px-5 py-3 ${tone}`} data-testid={`contact-${key}-slot`}>{inner}</div>
            )}
          </li>
        );
      })}
    </ul>
  );
}
